module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"marketingNoteMobile":"登録すると、受け入れ確認がすぐにできます！\\nいますぐ登録しよう！","signupForFreeMobile":"無料登録"},"en":{"marketingNoteMobile":"When you signup you can send inquiries to warehouses!","signupForFreeMobile":"Signup Free"}}')
  delete Component.options._Ctor
}
